export default __webpack_public_path__ + "static/Chalet-LondonSixty-a06e7b434b5ff22c56b750f0614c3a74.woff";